// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/arrow-down.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function ArrowDownIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M8.00044 14.6255C8.32609 14.6254 8.6393 14.4964 8.86958 14.2661L14.4428 8.69287C14.6865 8.4488 14.6867 8.05207 14.4428 7.80811C14.1989 7.56415 13.8022 7.56439 13.5581 7.80811L9.99113 11.375C9.56275 11.8034 9.34856 12.0176 9.16467 12.0321C9.00511 12.0446 8.84918 11.98 8.74524 11.8583C8.62544 11.7181 8.62544 11.4152 8.62544 10.8094V2.00049C8.62518 1.65569 8.34523 1.37575 8.00044 1.37549C7.65543 1.37549 7.3757 1.65553 7.37544 2.00049V10.8094C7.37544 11.4152 7.37544 11.7181 7.25564 11.8583C7.1517 11.98 6.99577 12.0446 6.83621 12.0321C6.65232 12.0176 6.43813 11.8034 6.00975 11.375L2.44282 7.80811C2.19887 7.56415 1.80217 7.56439 1.55806 7.80811C1.31398 8.05218 1.31398 8.44879 1.55806 8.69287L7.1313 14.2661C7.36168 14.4964 7.67467 14.6255 8.00044 14.6255Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
